// extracted by mini-css-extract-plugin
module.exports = {"view":"member-operations__View__view","instruction":"member-operations__View__instruction","actions":"member-operations__View__actions"};